// Module
var code = "<react-component name=\"SentMessages\"></react-component>\n";
// Exports
module.exports = code;